import { sendGTMEventNewsletterRegistration } from '@/api/gtm';

type PopupFormSuccessHandler = (container: Element) => void;

const POPUP_FORM_SUCCESS_HANDLERS: Record<string, PopupFormSuccessHandler> = {
  // 128114 - id формы подписки на новости
  '128114': () => sendGTMEventNewsletterRegistration('pop-up')
};

const POPMECHANIC_CONTAINER_PREFIX = 'popmechanic-container-';
const POPMECHANIC_CONTAINER_SELECTOR = `[id^="${POPMECHANIC_CONTAINER_PREFIX}"]`;

const getPopupFormId = (element: Element): string | null => {
  if (!element.id.startsWith(POPMECHANIC_CONTAINER_PREFIX)) return null;
  return element.id.slice(POPMECHANIC_CONTAINER_PREFIX.length);
};

export const mindboxPopupFormTracking = () => {
  const submittedContainers = new WeakSet<Element>();

  const handleContainer = (container: Element) => {
    const formId = getPopupFormId(container);
    const onSuccess = formId ? POPUP_FORM_SUCCESS_HANDLERS[formId] : undefined;
    if (!onSuccess || !container.classList.contains('popmechanic-success')) return;
    if (submittedContainers.has(container)) return;

    submittedContainers.add(container);
    onSuccess(container);
  };

  const scanContainers = (root: Element | Document) => {
    if (root instanceof Element && root.id.startsWith(POPMECHANIC_CONTAINER_PREFIX)) {
      handleContainer(root);
    }
    root.querySelectorAll(POPMECHANIC_CONTAINER_SELECTOR).forEach(handleContainer);
  };

  const observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
        handleContainer(mutation.target as Element);
      }

      mutation.addedNodes.forEach((node) => {
        if (node instanceof Element) {
          scanContainers(node);
        }
      });
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['class']
  });

  scanContainers(document.body);

  return () => observer.disconnect();
};
